<template>
  <v-dialog 
    :value="dialog" 
    persistent 
    max-width="800px">
    <v-card v-if="item && item.type == 'standardblock'">
      <v-toolbar 
        color="primary" 
        dark>
        <v-toolbar-title>
          <span class="headline">Add standard</span>            
        </v-toolbar-title>
      </v-toolbar>
      <v-card 
        v-show="item.options.length > 0 || item.html" 
        color="secondary lighten-5">
        <v-layout
          row 
          wrap>
          <v-flex
            sm12
            md1
            class="secondary"
          >    
            <v-layout 
              align-center 
              justify-center 
              fill-height 
              row>       
              <v-tooltip bottom>
                <v-icon slot="activator">visibility</v-icon>
                <span>Preview</span>
              </v-tooltip>
            </v-layout>
          </v-flex>
          <v-flex 
            sm12 
            md11>
            <v-card-text>
              <div v-html="item.html"/>
              <v-radio-group 
                :value="item.value" 
                :required="item.required" 
                :rules="[v => !item.required || !!v || 'Required']" 
                row>
                <v-radio 
                  v-for="(opt, index) in item.options"
                  :key="opt.label"
                  :label="opt.label"
                  :color="opt.value" 
                  :value="index" />                  
              </v-radio-group>
            </v-card-text> 
          </v-flex>
        </v-layout>
      </v-card>   
      <v-form 
        ref="form"
        v-model="valid"              
        lazy-validation>         
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <h2>Standard</h2>
              <v-flex xs12>
                <ckeditor 
                  :editor="editor" 
                  v-model="item.html" 
                  :config="editorConfig"/>
              </v-flex>
              <v-flex xs12>
                <v-card>
                  <v-card-title>
                    <h4>Options</h4>
                  </v-card-title>
                  <v-divider/>                 
                  <v-card-actions 
                    v-for="(val, i) in item.options"
                    :key="i">
                    <v-radio-group 
                      v-model="item.options[i].value" 
                      mandatory
                      :rules="[
                        v => !!v || 'required'
                      ]"
                      row>
                      <v-radio
                        label="pass"
                        color="success"
                        value="success"
                      />
                      <v-radio
                        label="warning"
                        color="warning"
                        value="warning"
                      />
                      <v-radio
                        label="fail"
                        color="error"
                        value="error"
                      />
                    </v-radio-group> 
                    <v-text-field
                      v-model="item.options[i].label"
                      append-icon="clear"
                      @click:append="removeOption(i)"
                      :rules="[
                        v => !optionChecker() || 'Duplicate value',
                        v => !!v && v.length > 1 && v.length < 100 || 'Must be between 2 and 100 characters'
                      ]"
                    />                      

                  </v-card-actions>
                  <v-btn 
                    absolute
                    fab 
                    bottom
                    right
                    dark 
                    color="primary" 
                    @click="addOption()">
                    <v-icon 
                      dark>add</v-icon>
                  </v-btn> 
                </v-card>
              </v-flex>
              <v-flex xs12>
                <v-radio-group 
                  v-model="item.required"
                  persistent-hint
                  hint="Is the text field mandatory"
                  row 
                >
                  <v-radio
                    :value="true"
                    label="Required"                      
                    color="primary" 
                  />
                  <v-radio
                    :value="false"
                    label="Optional"                      
                    color="primary" 
                  />
                </v-radio-group>                
              </v-flex>            
              <v-flex xs12>
                <v-radio-group 
                  v-model="item.show"
                  persistent-hint
                  hint="Should the element be displayed when editing a form or at all times"
                  row 
                >
                  <v-radio
                    :value="true"
                    label="Show always"                      
                    color="primary" 
                  />
                  <v-radio
                    :value="false"
                    label="Show in form"                      
                    color="primary" 
                  />                 
                </v-radio-group>                
              </v-flex>   
              <v-flex xs12>
                <v-checkbox 
                  v-model="item.csv" 
                  label="Include element in CSV"/>
              </v-flex>
              <v-flex 
                xs12 
                v-if="item.csv">                           
                <v-text-field
                  :rules="csvRules"
                  v-model="item.csvKey"                  
                  label="CSV key"  
                  persistent-hint
                  hint="CSV headers are generated from these Keys and must be unique"
                />                
              </v-flex>          
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-spacer/>
          <v-btn 
            color="primary" 
            flat 
            @click.native="close">Close</v-btn>
          <v-btn 
            v-if="standarditem.html" 
            color="red darken-1" 
            flat 
            @click.native="remove()">Delete</v-btn>         
          <v-btn 
            color="primary" 
            flat 
            @click.native="save(item)">{{ (standarditem.html ? 'Update' : 'Save') }}</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default {
  name: "Standardblock",
  props: {
    dialog: {
      type: Boolean,
      default: true
    },
    standarditem: {
      type: Object,
      default: null
    }
  },
  components: {
    ckeditor: CKEditor.component
  },
  data() {
    return {
      valid: true,
      checkbox: null,
      textRules: [
        v => !!v || "Required",
        v => (v && v.length < 5000) || "Text must be less than 5000 characters"
      ],
      csvRules: [
        v => !!v || "Required",
        v => /^[a-zA-Z0-9_]+$/.test(v) || "Alphanumeric and underscore"
      ],
      item: null,
      editor: ClassicEditor,
      editorConfig: {
        toolbar: [
          "heading",
          "|",
          "bold",
          "italic",
          "link",
          "bulletedList",
          "numberedList",
          "blockQuote",
          "undo",
          "redo"
        ]
      }
    };
  },
  watch: {
    standarditem: function(val) {
      this.item = JSON.parse(JSON.stringify(val));
    }
  },
  methods: {
    optionChecker() {
      return new Set(this.item.options).size !== this.item.options.length;
    },
    addOption() {
      this.item.options.push({ label: "" });
    },
    removeOption(index) {
      this.item.options.splice(index, 1);
    },
    save(item) {
      if (item.options.length > 0 || item.html) {
        if (this.$refs.form.validate()) {
          this.$emit("statusDialog", false);
          this.$emit("saveItem", item);
          this.$store.dispatch("setLoading", true);
        }
      }
    },
    remove() {
      this.$emit("statusDialog", false);
      this.$emit("saveItem", null);
      this.$store.dispatch("setLoading", true);
    },
    close() {
      this.$emit("statusDialog", false);
      this.$store.dispatch("sendNotification", {
        snackbar: true,
        color: "warning",
        text: "Input not saved"
      });
    }
  }
};
</script>
